<template>
  <div class="contranter">
    <div id="main">
      <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
      <img
        heigt="auto"
        v-if="curId == 1"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award1-desc.jpg"
      />
      <img
        heigt="auto"
        v-if="curId == 2"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award2-desc1.jpg"
      />
      <img
        heigt="auto"
        v-if="curId == 2"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award2-desc2.jpg"
      />
      <img
        heigt="auto"
        v-if="curId == 3"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award3-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 3"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award3-desc1.png"
      />

      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc1.png"
      />
      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc2.png"
      />
      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc3.png"
      />
      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc4.png"
      />
      <img
        heigt="auto"
        v-if="curId == 4"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award4-desc5.png"
      />

      <img
        heigt="auto"
        v-if="curId == 5"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award5-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 5"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award5-desc1.png"
      />

      <img
        heigt="auto"
        v-if="curId == 6"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award6-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 7"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award7-desc.png"
      />

      <img
        heigt="auto"
        v-if="curId == 8"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award8-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 8"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award8-desc1.png"
      />

      <img
        heigt="auto"
        v-if="curId == 9"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award9-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 9"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award9-desc1.png"
      />
      <img
        heigt="auto"
        v-if="curId == 10"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award10-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 10"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award10-desc1.png"
      />
      <img
        heigt="auto"
        v-if="curId == 11"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award11-desc.png"
      />

      <img
        heigt="auto"
        v-if="curId == 12"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award12-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 13"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award13-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 13"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award13-desc1.png"
      />

      <img
        heigt="auto"
        v-if="curId == 14"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award14-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 14"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award14-desc1.png"
      />
      <img
        heigt="auto"
        v-if="curId == 14"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award14-desc2.png"
      />
      <img
        heigt="auto"
        v-if="curId == 14"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award14-desc3.png"
      />

      <img
        heigt="auto"
        v-if="curId == 15"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award15-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 15"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award15-desc1.png"
      />
      <img
        heigt="auto"
        v-if="curId == 15"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award15-desc2.png"
      />
      <!-- <img heigt="auto" v-if="curId==16" class="detail-img" src="https://cdnzn.kai-dian.com/axor/v2/award1-desc.png"
           /> -->
      <img
        heigt="auto"
        v-if="curId == 17"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award17-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 18"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award18-desc.png"
      />
      <img
        heigt="auto"
        v-if="curId == 18"
        class="detail-img"
        src="https://cdnzn.kai-dian.com/axor/v2/award18-desc1.png"
      />
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Dashboard",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "AXOR室内设计奖",
      tab_index: 2,
      had_login: false,
      curId: 1,
    };
  },
  methods: {
    naviToDetail(item) {
      // this.$router.push()
    },
  },
  created() {
    //window.document.title = this.title;
    let that = this;
  },
  mounted() {
    let that = this;
    let phone_number = localStorage.getItem("mobile");
    that.curId = that.$route.params.id;
    console.log(that.curId);
    if (phone_number) {
      this.had_login = true;
      api
        .getMyInfo({
          user_phone: ops.encode(phone_number),
        })
        .then((res) => {
          that.u_info = res.data.data.info;
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detail-img {
  width: 8.5rem;
  display: block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Pro.vue